interface SegmentGroupHeaderProps {
  groupIndex: number
  depth: number
  isExceptGroup: boolean
}

const SegmentGroupHeader = ({
  groupIndex,
  depth,
  isExceptGroup,
}: SegmentGroupHeaderProps) => {
  const prefix = isExceptGroup ? 'EXCLUDED ' : ''
  const groupNumber = groupIndex + 1
  const nestedLabel = depth > 0 ? ` (Nested Level ${depth})` : ''

  return (
    <div className="thanx-ai-segment-visualization__group-header">
      {prefix}GROUP {groupNumber}
      {nestedLabel}
    </div>
  )
}

export default SegmentGroupHeader
